import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthProvider';
import { useNavigate } from 'react-router-dom';

function VerifyRegistration(props) {
    const [verificationCode, setVerificationCode] = useState('');
    const {verify, resendVerificationCode} = useContext(AuthContext);
    const navigate = useNavigate();
  
    const handleSubmit = (e) => {
      e.preventDefault();
      // Handle registration logic, e.g., send data to API
      verify(verificationCode);
      navigate('/login');
    };

    const handleResendVerificationCode = () => {
      console.log("Resend verification code clicked")
      resendVerificationCode();
    }
  
    return (
      <div className="App-body">
      <form onSubmit={handleSubmit}>
        Verify Email
        <div align="center">
        <input
          type="verificationCode"
          placeholder="Verification Code"
          value={verificationCode}
          className="text-box-style"
          onChange={(e) => setVerificationCode(e.target.value)}
        /></div>
        <div align="center">
        <button type="submit">Verify</button></div>
      </form>
      <div>
      <button onClick={handleResendVerificationCode}>Resend Verification Code</button></div>
      </div>
    );
  }

  export default VerifyRegistration;